import {Button, Card, Typography,} from "antd";
import {ArrowLeftOutlined,} from "@ant-design/icons";
import {Link} from "react-router-dom";
import {sprintf} from "@/lib/utils/sprintf";
import {URLS} from "@/lib/urls";

const {Text, Paragraph} = Typography;

export default function SurveyCard({survey}) {
    return (
        <Card
            hoverable
            className="
        overflow-hidden
        border-0
        shadow-md
        hover:shadow-2xl
        transition-all
        duration-300
        rounded-3xl
      "
            bodyStyle={{padding: 0}}
        >
            {/* Header */}
            <div
                className="
          bg-gradient-to-l
          from-indigo-600
          via-violet-600
          to-fuchsia-600
          p-6
          text-white
        "
            >
                <div className="flex  justify-between gap-4">
                    <div>

                        <h2 className="text-xl font-extrabold leading-relaxed">
                            {survey.title}
                        </h2>
                    </div>
                </div>
            </div>

            {/* Body */}
            <div className="p-6">
                <Paragraph

                    className="!text-gray-600 !leading-8 !mb-6"
                >
                    {survey.description}
                </Paragraph>


                <div className="flex items-center justify-between">
                    <div></div>
                    <div>
                        <Link to={sprintf(URLS.student.survey.publicSurveyAnswer, {id: survey.id})}>


                            <Button
                                type="primary"
                                size="large"
                                icon={<ArrowLeftOutlined/>}
                                className="!rounded-2xl !h-12 !px-6 !font-bold">
                                شرکت در نظرسنجی
                            </Button>
                        </Link>
                    </div>

                </div>
            </div>
        </Card>
    );
}